(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orelis-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeReviewCarousel = (section) => {
      if (section.dataset.orReviewsInitialized === 'true') return;

      const track = section.querySelector('[data-or-review-track]');
      if (!track) return;

      section.dataset.orReviewsInitialized = 'true';
      section.querySelectorAll('[data-or-review-direction]').forEach((button) => {
        button.addEventListener('click', () => {
          const firstCard = track.querySelector('.or-review-card');
          const styles = window.getComputedStyle(track);
          const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
          const distance = firstCard ? firstCard.getBoundingClientRect().width + gap : track.clientWidth * 0.88;
          const direction = Number(button.dataset.orReviewDirection);
          track.scrollLeft = track.scrollLeft + direction * distance;
        });
      });
    };

    const initializeAllReviewCarousels = (scope = document) => {
      scope.querySelectorAll('[data-or-reviews]').forEach(initializeReviewCarousel);
    };

    initializeAllReviewCarousels();
    document.addEventListener('shopify:section:load', (event) => initializeAllReviewCarousels(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orelis-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeStickyBar = (sticky) => {
      if (sticky.dataset.orStickyInitialized === 'true') return;

      const stickyButton = sticky.querySelector('[data-or-sticky-button]');
      const optionText = sticky.querySelector('[data-or-sticky-option]');
      const getProductInfo = () => document.querySelector('[id^="ProductInfo-"]');
      const getMainButton = () => {
        const productInfo = getProductInfo();
        return productInfo && productInfo.querySelector('[id^="ProductSubmitButton-"]');
      };
      const productInfo = getProductInfo();
      const mainButton = getMainButton();
      if (!productInfo || !mainButton || !stickyButton) return;

      sticky.dataset.orStickyInitialized = 'true';

      const syncState = () => {
        const productInfo = getProductInfo();
        const currentMainButton = getMainButton();
        if (!productInfo || !currentMainButton) return;
        const checkedOption = productInfo.querySelector('variant-selects input[type="radio"]:checked, variant-radios input[type="radio"]:checked');
        if (checkedOption && optionText) optionText.textContent = checkedOption.value;
        stickyButton.disabled = currentMainButton.disabled;
        const mainLabel = currentMainButton.querySelector('span');
        if (mainLabel && mainLabel.textContent.trim()) stickyButton.textContent = mainLabel.textContent.trim();
      };

      stickyButton.addEventListener('click', () => {
        const currentMainButton = getMainButton();
        if (currentMainButton && !currentMainButton.disabled) currentMainButton.click();
      });

      document.addEventListener('change', (event) => {
        if (event.target.matches('variant-selects input[type="radio"], variant-radios input[type="radio"]')) {
          requestAnimationFrame(syncState);
        }
      });
      new MutationObserver(syncState).observe(mainButton, { attributes: true, childList: true, subtree: true });

      const updateVisibility = () => {
        const currentMainButton = getMainButton();
        sticky.classList.toggle('is-visible', Boolean(currentMainButton && currentMainButton.getBoundingClientRect().bottom < 0));
      };

      document.addEventListener('scroll', updateVisibility, { passive: true });
      window.addEventListener('resize', updateVisibility);
      updateVisibility();
      syncState();
    };

    const initializeAllStickyBars = (scope = document) => {
      scope.querySelectorAll('[data-or-sticky-atc]').forEach(initializeStickyBar);
    };

    initializeAllStickyBars();
    document.addEventListener('shopify:section:load', (event) => initializeAllStickyBars(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-duorove"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initDuoRove = (scope = document) => {
      document.body.classList.add('duorove-product-page');
      const roots = [];
      if (scope.matches?.('.ois')) roots.push(scope);
      roots.push(...scope.querySelectorAll('.ois'));
      roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      if (root.dataset.browserTitle) document.title = root.dataset.browserTitle;
      const bundleButtons = [...root.querySelectorAll('.ois__bundle')];
      const bundleCards = [...root.querySelectorAll('.ois__bundle-card')];
      const colorButtons = [...root.querySelectorAll('.ois__color')];
      const variantRecords = [...root.querySelectorAll('[data-variant-record]')];
      const addonInputs = [...root.querySelectorAll('[data-addon]')];
      const addButton = root.querySelector('.ois__add');
      const addTotal = addButton?.querySelector('strong');
      const checkoutButton = root.querySelector('.ois__checkout');
      const checkoutTotal = checkoutButton?.querySelector('strong');
      const error = root.querySelector('.ois__cart-error');
      const sticky = root.querySelector('.ois__sticky');
      const stickyTotal = sticky?.querySelector('strong');
      const stickyButton = sticky?.querySelector('button');
      const thumbs = [...root.querySelectorAll('.ois__thumb')];
      const counter = root.querySelector('.ois__gallery-count');
      let selected = bundleButtons.find((button) => button.classList.contains('is-selected')) || bundleButtons[0];
      let selectedColor = selected?.closest('.ois__bundle-card')?.dataset.selectedColor || colorButtons[0]?.dataset.color;
      let imageIndex = 0;

      const formatter = new Intl.NumberFormat(root.dataset.locale || 'en-US', {
        style: 'currency',
        currency: root.dataset.currency || 'USD'
      });

      function selectedCard() {
        return selected?.closest('.ois__bundle-card');
      }

      function currentCardColor(card, slot = 'primary') {
        const dataKey = slot === 'secondary' ? 'selectedColorSecondary' : 'selectedColor';
        return card?.dataset[dataKey] || card?.querySelector(`[data-color-slot="${slot}"].is-selected`)?.dataset.color || card?.querySelector(`[data-color-slot="${slot}"]`)?.dataset.color;
      }

      function selectedAddons() {
        return addonInputs;
      }

      function selectedQuantity() {
        return Number(selectedCard()?.dataset.quantity || 1);
      }

      function syncVariant() {
        if (!selected) return;
        const record = variantRecords.find((item) => item.dataset.pack === selected.dataset.pack && item.dataset.color === selectedColor);
        if (!record) {
          selected.dataset.available = 'false';
          return;
        }
        selected.dataset.variantId = record.dataset.id;
        selected.dataset.price = record.dataset.price;
        selected.dataset.comparePrice = record.dataset.comparePrice;
        selected.dataset.available = record.dataset.available;
      }

      function syncBundleAvailability() {
        bundleButtons.forEach((button) => {
          const cardColor = currentCardColor(button.closest('.ois__bundle-card')) || selectedColor;
          const record = variantRecords.find((item) => item.dataset.pack === button.dataset.pack && item.dataset.color === cardColor);
          button.disabled = !record || record.dataset.available !== 'true';
        });
      }

      function totalCents() {
        let total = Number(selected?.dataset.price || 0) * selectedQuantity();
        selectedAddons().forEach((input) => {
          if (input.checked && !input.disabled) total += Number(input.dataset.price || 0);
        });
        return total;
      }

      function updateTotal() {
        const value = formatter.format(totalCents() / 100);
        if (addTotal) addTotal.textContent = `— ${value}`;
        if (checkoutTotal) checkoutTotal.textContent = `— ${value}`;
        if (stickyTotal) stickyTotal.textContent = value;
        const available = selected?.dataset.available === 'true';
        if (addButton) addButton.disabled = !available;
        if (checkoutButton) checkoutButton.disabled = !available;
        if (stickyButton) stickyButton.disabled = !available;
      }

      bundleButtons.forEach((button) => {
        button.tabIndex = button === selected ? 0 : -1;
        button.addEventListener('click', () => {
          selected = button;
          addonInputs.forEach((input) => {
            if (!input.disabled) input.checked = true;
          });
          bundleButtons.forEach((item) => {
            item.classList.toggle('is-selected', item === button);
            item.setAttribute('aria-checked', item === button ? 'true' : 'false');
            item.setAttribute('aria-expanded', item === button ? 'true' : 'false');
            item.tabIndex = item === button ? 0 : -1;
          });
          bundleCards.forEach((card) => {
            const isSelected = card === button.closest('.ois__bundle-card');
            card.classList.toggle('is-selected', isSelected);
            const details = card.querySelector('.ois__bundle-details');
            if (details) details.hidden = !isSelected;
          });
          selectedColor = currentCardColor(selectedCard());
          syncBundleAvailability();
          syncVariant();
          updateTotal();
        });
        button.addEventListener('keydown', (event) => {
          if (!['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].includes(event.key)) return;
          event.preventDefault();
          const direction = ['ArrowDown', 'ArrowRight'].includes(event.key) ? 1 : -1;
          let nextIndex = bundleButtons.indexOf(button);
          do {
            nextIndex = (nextIndex + direction + bundleButtons.length) % bundleButtons.length;
          } while (bundleButtons[nextIndex].disabled && bundleButtons[nextIndex] !== button);
          bundleButtons[nextIndex].focus();
          bundleButtons[nextIndex].click();
        });
      });

      colorButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const card = button.closest('.ois__bundle-card');
          if (!card) return;
          const slot = button.dataset.colorSlot || 'primary';
          const dataKey = slot === 'secondary' ? 'selectedColorSecondary' : 'selectedColor';
          const group = button.closest('[data-color-group]');
          card.dataset[dataKey] = button.dataset.color;
          group?.querySelectorAll('.ois__color').forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-selected', active);
            item.setAttribute('aria-checked', active ? 'true' : 'false');
          });
          const offerButton = card.querySelector('.ois__bundle');
          if (offerButton && offerButton !== selected) offerButton.click();
          if (slot === 'primary') {
            selectedColor = button.dataset.color;
            syncBundleAvailability();
            syncVariant();
          }
          updateTotal();
        });
      });

      bundleCards.forEach((card) => {
        card.dataset.quantity = card.dataset.quantity || '1';
        const output = card.querySelector('[data-quantity-control] output');
        card.querySelectorAll('[data-quantity-action]').forEach((button) => {
          button.addEventListener('click', () => {
            const delta = button.dataset.quantityAction === 'increase' ? 1 : -1;
            const next = Math.min(10, Math.max(1, Number(card.dataset.quantity || 1) + delta));
            card.dataset.quantity = String(next);
            if (output) output.textContent = String(next);
            const offerButton = card.querySelector('.ois__bundle');
            if (offerButton && offerButton !== selected) offerButton.click();
            updateTotal();
          });
        });
      });

      addonInputs.forEach((input) => input.addEventListener('change', updateTotal));

      function showImage(index) {
        if (!thumbs.length) return;
        imageIndex = (index + thumbs.length) % thumbs.length;
        const hero = root.querySelector('.ois__hero img');
        if (!hero) return;
        hero.src = thumbs[imageIndex].dataset.src;
        hero.removeAttribute('srcset');
        thumbs.forEach((thumb, position) => thumb.classList.toggle('is-active', position === imageIndex));
        thumbs[imageIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        if (counter) counter.textContent = `${imageIndex + 1} / ${thumbs.length}`;
      }

      thumbs.forEach((thumb) => thumb.addEventListener('click', () => showImage(Number(thumb.dataset.index))));
      root.querySelector('.ois__arrow--prev')?.addEventListener('click', () => showImage(imageIndex - 1));
      root.querySelector('.ois__arrow--next')?.addEventListener('click', () => showImage(imageIndex + 1));

      async function addSelection(goToCheckout) {
        if (!selected || addButton.disabled) return;
        error.hidden = true;
        addButton.disabled = true;
        if (checkoutButton) checkoutButton.disabled = true;
        if (stickyButton) stickyButton.disabled = true;
        const selectedItem = { id: Number(selected.dataset.variantId), quantity: selectedQuantity() };
        if (selected.dataset.pack === '2 DUOROVE') {
          selectedItem.properties = {
            [root.dataset.colorOneProperty || 'First DUOROVE color']: currentCardColor(selectedCard(), 'primary'),
            [root.dataset.colorTwoProperty || 'Second DUOROVE color']: currentCardColor(selectedCard(), 'secondary')
          };
        }
        const items = [selectedItem];
        selectedAddons().forEach((input) => {
          if (input.checked && !input.disabled) items.push({ id: Number(input.dataset.variantId), quantity: 1 });
        });
        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Unable to add this selection. Please review the options and try again.');
          window.location.assign(goToCheckout ? root.dataset.checkoutUrl : root.dataset.cartUrl);
        } catch (event) {
          error.textContent = event.message || 'Unable to add this selection. Please try again.';
          error.hidden = false;
          updateTotal();
        }
      }

      addButton?.addEventListener('click', () => addSelection(false));
      checkoutButton?.addEventListener('click', () => addSelection(true));
      stickyButton?.addEventListener('click', () => addSelection(true));
      root.querySelectorAll('[data-review-link]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = root.querySelector(link.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
        });
      });
      syncBundleAvailability();
      syncVariant();
      updateTotal();
      if (sticky) sticky.hidden = false;
      });
    };

    initDuoRove();
    document.addEventListener('shopify:section:load', (event) => initDuoRove(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ice-scraper"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initIceScraper = (scope = document) => {
      document.body.classList.add('icerotor-product-page');
      const roots = [];
      if (scope.matches?.('.ois')) roots.push(scope);
      roots.push(...scope.querySelectorAll('.ois'));
      roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      if (root.dataset.browserTitle) document.title = root.dataset.browserTitle;
      const bundleButtons = [...root.querySelectorAll('.ois__bundle')];
      const bundleCards = [...root.querySelectorAll('.ois__bundle-card')];
      const addonInputs = [...root.querySelectorAll('[data-addon]')];
      const addButton = root.querySelector('.ois__add');
      const addTotal = addButton?.querySelector('strong');
      const error = root.querySelector('.ois__cart-error');
      const sticky = root.querySelector('.ois__sticky');
      const stickyTotal = sticky?.querySelector('strong');
      const stickyButton = sticky?.querySelector('button');
      const headlinePrice = root.querySelector('[data-headline-price]');
      const headlineCompare = root.querySelector('[data-headline-compare]');
      const thumbs = [...root.querySelectorAll('.ois__thumb')];
      const counter = root.querySelector('.ois__gallery-count');
      let selected = bundleButtons.find((button) => button.classList.contains('is-selected')) || bundleButtons[0];
      let imageIndex = 0;

      const formatter = new Intl.NumberFormat(root.dataset.locale || 'en-US', {
        style: 'currency',
        currency: root.dataset.currency || 'USD'
      });

      function selectedCard() {
        return selected?.closest('.ois__bundle-card');
      }

      function selectedAddons() {
        return [...(selectedCard()?.querySelectorAll('[data-addon]') || [])];
      }

      function totalCents() {
        let total = Number(selected?.dataset.price || 0);
        selectedAddons().forEach((input) => {
          if (input.checked && !input.disabled) total += Number(input.dataset.price || 0);
        });
        return total;
      }

      function updateTotal() {
        const value = formatter.format(totalCents() / 100);
        if (addTotal) addTotal.textContent = `— ${value}`;
        if (stickyTotal) stickyTotal.textContent = value;
        if (headlinePrice && selected) headlinePrice.textContent = formatter.format(Number(selected.dataset.price || 0) / 100);
        if (headlineCompare && selected) {
          const comparePrice = Number(selected.dataset.comparePrice || 0);
          headlineCompare.textContent = formatter.format(comparePrice / 100);
          headlineCompare.hidden = comparePrice <= Number(selected.dataset.price || 0);
        }
        const available = selected?.dataset.available === 'true';
        if (addButton) addButton.disabled = !available;
        if (stickyButton) stickyButton.disabled = !available;
      }

      bundleButtons.forEach((button) => {
        if (button.dataset.available !== 'true') button.disabled = true;
        button.tabIndex = button === selected ? 0 : -1;
        button.addEventListener('click', () => {
          selected = button;
          bundleButtons.forEach((item) => {
            item.classList.toggle('is-selected', item === button);
            item.setAttribute('aria-checked', item === button ? 'true' : 'false');
            item.setAttribute('aria-expanded', item === button ? 'true' : 'false');
            item.tabIndex = item === button ? 0 : -1;
          });
          bundleCards.forEach((card) => {
            const isSelected = card === button.closest('.ois__bundle-card');
            card.classList.toggle('is-selected', isSelected);
            const details = card.querySelector('.ois__bundle-details');
            if (details) details.hidden = !isSelected;
          });
          selectedAddons().forEach((input) => {
            if (!input.disabled) input.checked = true;
          });
          updateTotal();
        });
        button.addEventListener('keydown', (event) => {
          if (!['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].includes(event.key)) return;
          event.preventDefault();
          const direction = ['ArrowDown', 'ArrowRight'].includes(event.key) ? 1 : -1;
          let nextIndex = bundleButtons.indexOf(button);
          do {
            nextIndex = (nextIndex + direction + bundleButtons.length) % bundleButtons.length;
          } while (bundleButtons[nextIndex].disabled && bundleButtons[nextIndex] !== button);
          bundleButtons[nextIndex].focus();
          bundleButtons[nextIndex].click();
        });
      });

      addonInputs.forEach((input) => input.addEventListener('change', updateTotal));

      function showImage(index) {
        if (!thumbs.length) return;
        imageIndex = (index + thumbs.length) % thumbs.length;
        const hero = root.querySelector('.ois__hero img');
        if (!hero) return;
        hero.src = thumbs[imageIndex].dataset.src;
        hero.removeAttribute('srcset');
        thumbs.forEach((thumb, position) => thumb.classList.toggle('is-active', position === imageIndex));
        thumbs[imageIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        if (counter) counter.textContent = `${imageIndex + 1} / ${thumbs.length}`;
      }

      thumbs.forEach((thumb) => thumb.addEventListener('click', () => showImage(Number(thumb.dataset.index))));
      root.querySelector('.ois__arrow--prev')?.addEventListener('click', () => showImage(imageIndex - 1));
      root.querySelector('.ois__arrow--next')?.addEventListener('click', () => showImage(imageIndex + 1));

      async function addSelection() {
        if (!selected || addButton.disabled) return;
        error.hidden = true;
        addButton.disabled = true;
        if (stickyButton) stickyButton.disabled = true;
        const items = [{ id: Number(selected.dataset.variantId), quantity: 1 }];
        selectedAddons().forEach((input) => {
          if (input.checked && !input.disabled) items.push({ id: Number(input.dataset.variantId), quantity: 1 });
        });
        const cartItems = items.map((item) => `${item.id}:${item.quantity}`).join(',');
        window.location.assign(`${window.Shopify.routes.root}cart/${cartItems}`);
      }

      addButton?.addEventListener('click', addSelection);
      stickyButton?.addEventListener('click', addSelection);
      updateTotal();
      if (sticky) sticky.hidden = false;
      });
    };

    initIceScraper();
    document.addEventListener('shopify:section:load', (event) => initIceScraper(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
